import { openExternal } from "../discord/handshake";
import { useT } from "../i18n/context";
import { useStore } from "../store";

/** The community server's permanent invite (review 0022 decision 150); Discord opens it in place. */
export const COMMUNITY_INVITE = "https://discord.gg/HehvsjHhCs";

/**
 * "Meet other players: High Card Club server" (decision 150): where players from different servers
 * can talk, find a regular table and add each other as friends.
 */
export function CommunityLink({ className = "" }: { className?: string }) {
  const { t } = useT();
  const sdk = useStore((s) => s.sdk);
  return (
    <p className={`m-0 text-[13px] text-ink/80 ${className}`}>
      {t("community.lead")}{" "}
      <button
        type="button"
        className="font-bold text-gold underline underline-offset-2"
        onClick={() => void openExternal(sdk, COMMUNITY_INVITE)}
      >
        {t("community.link")}
      </button>
    </p>
  );
}
